export default {
    lang: {
        name: 'Want to have'
    }
}